(function (c2, $) {
  "use strict";

  /* ── Expiring Soon dashboard widget (CMP-4067 phase 5) ──
   *
   * A server-side c2 DataTable of the viewer's soon-to-expire resources and
   * servers. When the widget is configured with a resource/server action, each
   * row's Actions column carries a "Run action" button (data-action-kind /
   * -id / -target). Clicking it POSTs to the v3 runAction endpoint for that
   * resource/server and reloads the table. (View is a plain link.)
   *
   * The runAction endpoint enforces the real action permission server-side, so
   * a configured action id can never escalate beyond what the viewer may run.
   */

  function runAction(kind, actionId, target, csrfToken) {
    var base = kind === "server" ? "serverActions" : "resourceActions";
    var bodyKey = kind === "server" ? "server" : "resource";
    var body = {};
    body[bodyKey] = target;
    return $.ajax({
      url: "/api/v3/cmp/" + base + "/" + actionId + "/runAction/",
      type: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(body),
      headers: csrfToken ? { "X-CSRFToken": csrfToken } : {},
    });
  }

  function init(selector, opts) {
    opts = opts || {};
    var $table = $(selector);
    if (!$table.length || !c2.dataTables) {
      return;
    }

    // Show 5 rows per page (5 isn't in the c2 default lengthMenu).
    // stateSave is on by default and would restore a previously-used page
    // length from localStorage, overriding pageLength — disable it so this
    // compact widget always starts at 5.
    c2.dataTables.init(selector, {
      pageLength: 5,
      lengthMenu: [5, 10, 25, 50],
      stateSave: false,
    });

    // Delegated row actions (rows are re-rendered each draw).
    $table.on("click", ".exp-action", function () {
      var $btn = $(this);
      var kind = $btn.data("action-kind");
      var actionId = $btn.data("action-id");
      var target = $btn.data("target");
      if (!actionId || !target) {
        return;
      }
      $btn.prop("disabled", true);
      runAction(kind, actionId, target, opts.csrfToken)
        .done(function () {
          if (c2.alerts) {
            c2.alerts.addGlobalAlert("Action started.", "success", true, 4000);
          }
          $table.DataTable().ajax.reload(null, false);
        })
        .fail(function () {
          $btn.prop("disabled", false);
          if (c2.alerts) {
            c2.alerts.addGlobalAlert(
              "Could not run the action.",
              "error",
              true,
              5000,
            );
          }
        });
    });
  }

  c2.dashboardExpiring = { init: init };
})(window.c2, window.jQuery);
